<template>
    <MainContent
        title="Crear nuevo pack de eventos"
    >
        <template v-slot:header>
            <h3>Datos del pack</h3>
        </template>
        <template v-slot:content>
            <Form
                :data="data"
                @terminado="crearPack()"
            />
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '../../../components/backend/components/MainContent.vue'
    import Form from '@/components/backend/pack-eventos/Form.vue'

    export default {
        data() {
            return {
                data: {
                    provincia_id: null,
                    filters: {}
                }
            }
        },
        methods: {
            crearPack() {
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.store'), this.data).then(res => {
                    this.$router.push({ name: 'back.packs-events.index' });
                });
            }
        },
        components: {
            MainContent, Form
        }
    }
</script>